export const Config = {
    Url
}

function Url() : string {
    return "";
    //return "https://localhost:7175";
}